<template>
  <div>
    <div class="site-feature">
      <div class="container">
        <div :class="item.section_value.length % 3 == 0 ? 'site-feature-style1' : 'site-feature-style2'">
          <div class="site-feature-item" v-for="(itemFeature, indexFeature) in item.section_value" :key="indexFeature">
            <div class="feature-media">
              <div class="media-size">
                <img :src="currentUrl + '/img/sale_page_single/' + itemFeature.photo" />
                <div class="icon-top-right icon-top-right-color" v-if="itemFeature.icon!=''">
                  <i :class="'icon-top-right-font fas '+itemFeature.icon"></i>
                </div>
              </div>
            </div>
            <div class="feature-topic" v-html="itemFeature.detail"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    ...mapGetters(['currentUrl'])
  }
}
</script>

<style lang="scss" scoped>
</style>